import { interactive } from "@api/courses/exams/interactive/path";
import { fileBased } from "@api/courses/exams/fileBased/path";
import { states } from "@api/courses/exams/stats/path";

export const exams = {
  interactive,
  fileBased,
  states,
};
